module.exports = "/_next/static/images/12-1-f920e29584d45fc8960a2c23a0401693.svg";